import client, { url } from './client';
import qs from 'qs';

export const search = ({ type, keyword, clubID, socketKey }) => {
  const queryString = qs.stringify({
    type,
    keyword,
    clubID,
    socketKey,
  });
  return client.get(`${url}/api/search?${queryString}`);
};

export const loadClubMemberList = ({clubID, page, searchText, type, socketKey, membershipTitle, memberState, sex}) => {
  const queryString = qs.stringify({
    page,
    searchText,
    type,
    socketKey,
    membershipTitle,
    memberState,
    sex,
  });
  return client.get(`${url}/api/search/${clubID}?${queryString}`);

}

export const loadClubMembershipTitles = ({clubID, socketKey}) => {
  return client.get(`${url}/api/search/membershiptypes/${clubID}?${qs.stringify({ socketKey })}`);
}

export const loadClubMembershipList = ({clubID, socketKey}) => {
    const queryString = qs.stringify({
      socketKey,
    });
    return client.get(`${url}/api/search/membership/${clubID}?${queryString}`);
  
  }

export const clubMemberSearch = ({ clubID, keyword, page, limit, gender, platform, socketKey }) => {
  const queryString = qs.stringify({
    keyword,
    page,
    limit,
    gender,
    platform,
    socketKey,
  });
  return client.get(`${url}/api/clubs/club/member/search/${clubID}?${queryString}`);
};